import { render, staticRenderFns } from "./Input-Principal.vue?vue&type=template&id=b63ce038&lang=pug"
import script from "./Input-Principal.vue?vue&type=script&lang=ts"
export * from "./Input-Principal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports